export const PERSONAL = 'personal';
export const MORTGAGE = 'mortgage';
export const PURCHASE = 'purchase';
export const REFI = 'refinance';
export const HOME_EQUITY = 'homeequity';
export const AUTO = 'auto';
export const BUSINESS = 'business';
export const CREDITCARDS = 'creditcards';
